import { PendingCancellations } from "@/features/orders/pending-cancellations";
import { useCenterScopeNotApplicable } from "@/contexts/carrier-scope-context";

const CancellationsScreen = () => {
  // Cancellations live at the shipment level — carrier-scoped, not
  // center-scoped. Disable the center picker.
  useCenterScopeNotApplicable();

  return (
    <div className="p-4">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Cancellations</h1>
      </div>
      <PendingCancellations />
    </div>
  );
};

export default CancellationsScreen;
